<template>
  <v-app>
    <portal-sysbar :show-customer="false"></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="$t('message.aside.userlist')"></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content">
        <div class="justify-end">
          <v-btn small color="primary" @click="openModal">
            <v-icon>mdi-plus</v-icon> Nouveau
          </v-btn>
        </div>
        <v-data-table :items="data" :headers="userHeader" :loading="loading" loading-text="Loading... Please wait">
          <template v-slot:item.del="{ del }">
            {{ del ? "Inactif" : "Actif" }}
          </template>
        </v-data-table>
        <v-dialog v-model="createModal" width="400">
          <v-card>
            <v-card-title>
              Créer un utilisateur
            </v-card-title>
            <v-card-text>
              <div class="justify-end">
                <v-btn small color="secondary" @click="resetFormFields">
                  <v-icon>mdi-playlist-remove</v-icon> Réinitialiser
                </v-btn>
              </div>
              <v-form ref="userForm" v-model="formValid">
                <v-text-field label="Nom d'utilisateur" hint="Par défaut on utilise prénom.nom" required
                  :rules="rules.username" v-model="formData.user.username"></v-text-field>
                <v-text-field label="Prénom et nom" hint="Prénom NOM (ex: Michel DUPONT)"
                  v-model="formData.user.name"></v-text-field>
                <v-text-field label="Adresse mail" :rules="rules.mail" required
                  v-model="formData.user.mail"></v-text-field>
                <v-text-field label="N° de téléphone" :rules="rules.tel" v-model="formData.user.tel"></v-text-field>
                <v-select label="Profil" :items="fonctions" :rules="rules.profile" item-text="description"
                  item-value="id" v-model="formData.profil"></v-select>
                <v-autocomplete :label="$t('message.selectCustomer', { value: 'default' })" dense :items="getterClient"
                  item-text="name" item-value="customernum" v-model="formData.customer"></v-autocomplete>

              </v-form>
              <div class="validation">
                <v-btn color="primary" @click="sendForm" :disabled="!formValid">
                  Valider
                </v-btn>
                <div v-if="loadingCreation" class="loading-creation">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  Création en cours
                </div>
                <div v-if="successCreation" class="success-creation">
                  <v-icon color="green">mdi-check</v-icon> Création réussie
                </div>
                <div v-if="errorCreation" class="error-creation">
                  <v-icon color="red">mdi-cancel</v-icon> {{ errorCreation }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import CoreService from "../services/CoreService";
import { mapGetters } from "vuex";


export default {
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
  },
  data() {
    return {
      userHeader: [
        { text: "Nom", value: "name" },
        { text: "Adresse mail", value: "mail" },
        { text: "Profil", value: "fonction.description" },
        { text: "Scope", value: "scope.description" },
        { text: "Client", value: "client.description" },
        { text: "Etat", value: "del" }
      ],
      data: [],
      fonctions: [],
      formData: { user: {} },
      loading: true,
      createModal: false,
      loadingCreation: false,
      successCreation: false,
      errorCreation: null,
      formValid: false,
      rules: {
        username: [
          v => !!v || 'Champ requis',
        ],
        mail: [
          v => !!v || 'Champ requis',
          v => /^.+@.+\..+$/.test(v) || 'Format d\'adresse mail incorrect'
        ],
        tel: [
          v => (typeof v != undefined || /^[0-9]*$/.test(v)) || 'Format de numéro de téléphone incorrect'
        ],
        profile: [
          v => !!v || 'Champ requis'
        ]
      }
    }
  },
  mounted() {
    CoreService.findAllUsers().then(({ data }) => {
      this.data = data;
      this.loading = false;
    });
    CoreService.findAllRoles().then(({ data }) => {
      this.fonctions = data.filter(p => p.typeRole === 3)
    });
  },
  methods: {
    openModal() {
      this.createModal = true;
    },
    sleep(ms) {
      return new Promise(p => setTimeout(p, ms));
    },
    sendForm() {
      this.$refs.userForm.validate();
      this.loadingCreation = true;
      this.errorCreation = null;
      CoreService.signup(this.formData).then(() => {
        this.loadingCreation = false;
        this.successCreation = true;
        this.sleep(1500).then(() => {
          this.$refs.userForm.reset();
          this.successCreation = false;
          this.createModal = false;
        })
      }).catch((error) => {
        this.loadingCreation = false;
        this.errorCreation = error.response.data;
      })
    },
    resetForm() {
      this.loadingCreation = false;
      this.successCreation = false;
      this.errorCreation = null;
    },
    resetFormFields() {
      this.$refs.userForm.reset();
    }
  },
  watch: {
    createModal(newVal) {
      if (!newVal) {
        this.resetForm();
      }
      return newVal;
    }
  },
  computed: {
    ...mapGetters("auth", {
      getterClient: "getClients"
    }),
  },
}
</script>

<style scoped>
.justify-end {
  display: flex;
  justify-content: end;
}

.validation {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.loading-creation {
  color: blue;
}

.success-creation {
  color: green;
}

.error-creation {
  color: red;
}
</style>